import { Grid, Typography, withStyles } from '@material-ui/core';
import { BlocMaintenance, Card, Footer, Snack } from 'bc-front-sagacomponents';
import { isAfter, isBefore, isEqual } from 'date-fns';
import React, { useEffect } from 'react';
import { Offline } from 'react-detect-offline';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import Layout from '../../components/Layout';
import useWindowDimensions from '../../hooks/useWindowDimension';
import Alerte from '../../images/Alerte';
import illuCagnote from '../../images/consulter-cagnotefid.jpg';
import illuGaranties from '../../images/consulter-garanties.jpg';
import IllustrationSagaHomeSvg from '../../images/illustration-saga-accueil';
import illuDepannage from '../../images/lancer-depannage.jpg';
import illuCarte from '../../images/visualiser-carte.jpg';
import { getConfirmationCreationCompte, setConfirmationCreationCompte } from '../../redux/CompteRedux';
import { RootState } from '../../redux/reducers';
import {
  getMaintenanceDateDebut,
  getMaintenanceDateFin,
  getMsgMaintenanceDateDebut,
  getMsgMaintenanceDateFin,
  getMsgMaintenanceEn,
  getMsgMaintenanceFr,
} from '../../services/Config';
import CardImg from './CardImg';
import styles from './style';

interface Props {
  classes?: any;
}
export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;
const HomePage = (props: Props) => {
  const { classes } = props;

  const { width } = useWindowDimensions();

  const maintenanceFr = getMsgMaintenanceFr();
  const maintenanceEn = getMsgMaintenanceEn();
  const dateDebutMaintenanceMsg = getMsgMaintenanceDateDebut();
  const dateFinMaintenanceMsg = getMsgMaintenanceDateFin();
  const maintenanceDateDebut = getMaintenanceDateDebut();
  const maintenanceDateFin = getMaintenanceDateFin();

  const hideConnectionBtn: boolean =
    maintenanceDateDebut && maintenanceDateFin
      ? (isAfter(new Date(), new Date(maintenanceDateDebut)) || isEqual(new Date(), new Date(maintenanceDateDebut))) &&
        (isBefore(new Date(), new Date(maintenanceDateFin)) || isEqual(new Date(), new Date(maintenanceDateFin)))
      : true;

  // CONFIRMATION COMPTE
  const dispatch = useDispatch();
  const confirmationCreationCompte = useSelector((state) => getConfirmationCreationCompte(state));
  const handleClose = () => {
    dispatch(setConfirmationCreationCompte(false));
  };
  useEffect(() => {
    if (confirmationCreationCompte) {
      const timer = setTimeout(() => {
        dispatch(setConfirmationCreationCompte(false));
      }, 10000);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [confirmationCreationCompte, dispatch]);

  return (
    <Layout>
      <div className={classes.homePage}>
        {confirmationCreationCompte && (
          <Snack
            type="success"
            message="Votre compte a été créé, un email vous été envoyé pour l'activer"
            onClose={handleClose}
          />
        )}

        <Grid container alignItems="center" justify="space-between" className={classes.title}>
          <div>
            <Typography variant="h1">
              <strong>La route</strong> plus sereine...
            </Typography>
            <Typography variant="body2">
              Avec votre carte de vrais avantages pour votre véhicule, pour vous et votre famille... et pour votre
              budget !
            </Typography>
          </div>
          <Card className={classes.msgPremiereVisite}>
            <Alerte />
            <p>
              Plus moderne, plus pratique... Notre site a été totalement repensé pour vous. L'accès à l'information y
              est simplifié. <br />
              L'accès au site a été revu afin qu'il soit plus facile, lors de votre première connexion.{' '}
              <a href="/creation-compte">Cliquer ici pour créer votre compte.</a>
            </p>
          </Card>
        </Grid>
        <BlocMaintenance
          msgMaintenanceFr={maintenanceFr || ' '}
          msgMaintenanceEn={maintenanceEn || ' '}
          dateDebutMsgMaintenance={dateDebutMaintenanceMsg || ' '}
          dateFinMsgMaintenance={dateFinMaintenanceMsg || ' '}
        />
        <Card className={classes.container}>
          <Typography variant="h3">Qui sommes-nous ?</Typography>
          <p>
            Saga est une société leader dans la conception de solutions de fidélisation et la mise en place de
            prestations additionnelles proposées par votre distributeur automobile à l'occasion de l'achat de votre
            véhicule.
            <br />
            Ces prestations viennent compléter votre assurance automobile.
            <br />
            Notre offre est présente sur le marché de l'automobile depuis plus de 30 ans. Nous gérons aujourd'hui plus
            de 400 000 véhicules en partenariat avec 200 distributeurs automobiles qui nous ont fait confiance sur
            l'ensemble du territoire Français, parmi les plus grandes marques.
            <br />
            Saga est agréé par le SRA* en tant qu'organisme de marquage antivol des véhicules.
          </p>
          <br />
          <span className={classes.asterisk}>
            *Sécurité et Réparation Automobiles, organisme créé à l'initiative des assureurs français
          </span>
          <Offline>
            Vous êtes hors ligne, certaines fonctionnalités ne fonctionneront pas. <br />
            <a href="/depannage">Lancer le dépannage</a>
          </Offline>
        </Card>
        <Card className={classes.containerAvantages}>
          <Typography variant="h3">Vos avantages*</Typography>
          <div className={classes.containerCards}>
            <CardImg title="Consulter mes avantages" img={illuGaranties} />
            <CardImg title="Visualiser ma carte" img={illuCarte} />
            <CardImg title="Lancer un dépannage" img={illuDepannage} />
            <CardImg title="Consulter ma cagnotte fidélité" img={illuCagnote} />
          </div>
          <span className={classes.asterisk}>*Selon la formule souscripte</span>
        </Card>
      </div>
      {width > 1347 && (
        <div className={classes.illuHome}>
          <IllustrationSagaHomeSvg></IllustrationSagaHomeSvg>
        </div>
      )}
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(HomePage);
